module.exports = {"TXTACL_Internet_Connection_Lost":{"id":"TXTACL_Internet_Connection_Lost","defaultMessage":"Se ha perdido la conexión a Internet"}}